
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-elchemy/intl",
      function () {
        return require("private-next-pages/contact-elchemy/intl/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact-elchemy/intl"])
      });
    }
  